import 'temporal-polyfill/global';

import { FormatterProvider } from '@earzzai/i18n-react';
import { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider as ReduxProvider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { i18n } from './i18n';
import { AccountProvider } from './providers/AccountProvider';
import { ColorPreferenceProvider } from './providers/ColorPreferenceProvider';
import { ErrorDisplayProvider } from './providers/ErrorDisplayProvider';
import { PreloadProvider } from './providers/PreloadProvider';
import { router } from './router';
import { persistor, store } from './store';
import {
  initializeCookieHub,
  initializeGoogleTagManager
} from './utils/tracking';

function App() {
  useEffect(() => {
    initializeCookieHub();
    initializeGoogleTagManager();
  });

  return (
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <FormatterProvider>
            <ErrorDisplayProvider>
              <AccountProvider>
                <PreloadProvider>
                  <ColorPreferenceProvider>
                    <RouterProvider router={router} />
                  </ColorPreferenceProvider>
                </PreloadProvider>
              </AccountProvider>
            </ErrorDisplayProvider>
          </FormatterProvider>
        </I18nextProvider>
      </PersistGate>
    </ReduxProvider>
  );
}

/* eslint-disable-next-line no-restricted-exports */
export default App;
